// extracted by mini-css-extract-plugin
module.exports = {"SearchBar":"SearchBar_SearchBar__Mcp7Z","SearchInput":"SearchBar_SearchInput__2V8Ny"};